import { Title, Text, Tabs } from "@mantine/core";
import { IconSettings, IconKey, IconCode } from "@tabler/icons-react";

export function SettingsPage() {
  return (
    <>
      <Title order={2} mb="md">
        Settings
      </Title>

      <Tabs defaultValue="general">
        <Tabs.List>
          <Tabs.Tab value="general" leftSection={<IconSettings size={16} />}>
            General
          </Tabs.Tab>
          <Tabs.Tab value="api-keys" leftSection={<IconKey size={16} />}>
            API Keys
          </Tabs.Tab>
          <Tabs.Tab value="sdk-tokens" leftSection={<IconCode size={16} />}>
            SDK Tokens
          </Tabs.Tab>
        </Tabs.List>

        <Tabs.Panel value="general" pt="md">
          <Text c="dimmed">Workspace settings will go here.</Text>
        </Tabs.Panel>

        <Tabs.Panel value="api-keys" pt="md">
          <Text c="dimmed">
            Manage your LLM provider API keys (BYOK) here.
          </Text>
        </Tabs.Panel>

        <Tabs.Panel value="sdk-tokens" pt="md">
          <Text c="dimmed">
            Manage SDK tokens for programmatic access here.
          </Text>
        </Tabs.Panel>
      </Tabs>
    </>
  );
}
